<template>
    <div class="container">
        <container :active_path="path"  :plate="'云项目'">
            <div class="base-warp">
                <div class="head">
                    <el-form :model="form" ref="form" label-width="80px" :inline="true" size="normal">
                        <el-form-item label="关键字">
                            <el-input v-model="form.keyword" size="mini" placeholder="文章标题"></el-input>
                        </el-form-item>
                        <el-form-item label="发布日期">
                            <el-date-picker
                            v-model="form.date"
                            type="daterange"
                            size="mini"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="公众号">
                            <el-select v-model="form.source" placeholder="请选择公众号" size="mini" clearable>
                                <el-option :label="item" :value="item" v-for="(item, index) in sources" :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="confirm" size="mini">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="pull" size="mini" v-if="isAllCity">拉取公众号文章</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-box">
                    <el-table :data="tableData" 
                    border 
                    v-loading="loading"
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column label="序号" width="60" type="index"></el-table-column>
                        <el-table-column label="标题" prop="title" show-overflow-tooltip></el-table-column>
                        <el-table-column label="作者" prop="author" width="120" show-overflow-tooltip></el-table-column>
                        <el-table-column label="关联城市" prop="city" width="80" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column label="标签" prop="digest" show-overflow-tooltip></el-table-column>
                        <el-table-column label="公众号" prop="official" width="120" show-overflow-tooltip></el-table-column>
                        <el-table-column label="发布时间" prop="create_time" show-overflow-tooltip></el-table-column>
                        <el-table-column label="添加时间" prop="addDate" show-overflow-tooltip></el-table-column>
                        <el-table-column label="操作" width="330" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <a class="a-link" :href="scope.row.url" target="_blank">预览</a>
                                <el-button type="warning" size="mini" v-if="isAllCity" @click="changeCity(scope.row)">更改城市</el-button>
                                <el-button type="danger" size="mini" @click="del(scope.row, scope.$index)">删除</el-button>
                                <el-button v-if="!scope.row.address" type="primary" size="mini" @click="setAddress(scope.row)">设置地址</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
                <el-dialog
                    title="设置公众号链接"
                    :visible.sync="showdialog"
                    width="800px"
                    v-dialogDrag>
                    <div class="dia-box">
                        <div class="head row">
                            <div class="title">{{checkitem.title}}</div>
                        </div>
                        <div class="row">
                            <el-input v-model="checkaddress" placeholder="https://mp.weixin.qq.com/s/" size="mini" clearable></el-input>
                        </div>
                        <div class="row">
                            <el-button class="btn" type="primary" size="mini" @click="saveaddress">保存</el-button>
                        </div>
                    </div>
                </el-dialog>
                
            </div>
        </container>
        <router-view></router-view>
    </div>
</template>

<script>
import Container from '../../../components/container.vue'
export default {
    components: {
        Container,
    },
    data() {
        return{
            path: '/project/article',
            form: {
                keyword: '',
                date: [],
                source: '',
            },
            sources: ['浩哥看市', '浩哥观商业', '汉悦汇'],
            pageNo: 1,
            pagesize: 14,
            tableData: [],
            loading: false,
            total: 0,
            showdialog: false,
            checkitem: '',
            checkaddress: '',
            city:'',
            isAllCity:true,
        }
    },
    mounted () {
        let city = this.$store.getters.getuser.city;
        if(city === '全部'){
            this.isAllCity = true;
        }else{
            this.isAllCity = false;
            this.city = city;
        }
        this.gettabledata();
    },
    methods: {
        del(item, index) {
            this.$confirm('是否确定删除文章').then(
                confirm=>{
                    var params = {
                        id: item._id['$oid'],
                    }
                    this.$api.delArticle(params).then(
                        data=>{
                            this.$message.success(data);
                            this.tableData.splice(index, 1);
                        }
                    )
                },
                cancel=>{}
            )
        },
        saveaddress() {
            var address = this.checkaddress;
            if (address.indexOf('https://mp.weixin.qq.com/s/')<0){
                this.$message.error('地址填写错误，请以https://mp.weixin.qq.com/s/开头');
                return;
            }
            var id = this.checkitem._id['$oid'];
            if (!id){
                this.$message.error('请先选择一篇文章来设置地址');
                return;
            }
            var params = {
                id,
                address,
            }
            this.$api.setNewAddress(params).then(
                data=>{
                    this.$message.success('设置地址成功');
                    this.checkitem = '';
                    this.checkaddress = '';
                    this.showdialog = false;
                }
            )
        },
        setAddress(item) {
            this.showdialog = true;
            this.checkitem = item;
        },
        gettabledata() {
            var params = {
                pageNo: this.pageNo,
                pagesize: this.pagesize,
                keyword: this.form.keyword,
                date: JSON.stringify(this.form.date),
                official: this.form.source,
                city:this.city,
            }
            this.$api.getnewsList(params).then(
                data=>{
                    let {list, total} = data;
                    this.total = total;
                    this.tableData = list;
                }
            )
        },
        confirm() {
            this.pageNo = 1;
            this.gettabledata();
        },
        currentChange(page) {
            this.pageNo = page;
            this.gettabledata();
        },
        pull() {
            this.$router.push({path: '/project/article/pull'})
        },
        changeCity(row){
            let id = row._id['$oid'];
            let city = row.city
            this.$router.push({path: '/project/article/changeCity',query:{id,city}})
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (from.path == "/project/article/pull" || from.path == "/project/article/changeCity"){
            this.gettabledata();
        }
        next();
    },
}
</script>

<style lang="scss" scoped>
.a-link{
    margin-left: 20px;
    margin-right: 20px;
}
::v-deep .el-dialog__header{
    border-bottom: 1px solid #f7f7f7;
}
.dia-box{
    .head{
        margin-bottom: 10px;
        .title{
            line-height: 40px;
        }
    }
    .row{
        margin-bottom: 10px;
        overflow: hidden;
        .btn{
            float: right;
        }
    }
}
</style>